export default __webpack_public_path__ + "static/media/tripfighter.a58d9a35.png";